import type { WorkshopTreeReplacement } from '../../../../api/workshops';

/** "1 Dwarf Jade", or the count alone when the species was never recorded. */
export function TreeReplacementTrees({ pickup }: { pickup: WorkshopTreeReplacement }) {
  const count = pickup.treeCount ?? 1;
  const species = pickup.treeSpecies?.name;
  return (
    <div style={{ gridArea: 'trees', fontSize: 12, color: 'var(--nb-ink-2)', minWidth: 0 }}>
      {species ? (
        `${count} ${species}`
      ) : (
        <>
          {count} {count === 1 ? 'tree' : 'trees'}
          <span style={{ color: 'var(--nb-subtle)' }}> · species not recorded</span>
        </>
      )}
    </div>
  );
}
